exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\npre[data-v-295d0f2b] {\n   overflow-x: auto;\n   white-space: pre-wrap;\n   white-space: -moz-pre-wrap;\n   white-space: -pre-wrap;\n   white-space: -o-pre-wrap;\n   word-wrap: break-word;\n}\n", ""]);

// exports
